// extracted by mini-css-extract-plugin
module.exports = {"row":"ProductsDashboard_row__1GOqx","col":"ProductsDashboard_col__28TIj","card":"ProductsDashboard_card__2Tgj4"};